import { useEffect, useState } from 'react';
import catalogService from '../services/catalogService';

export const useHomeCategoryCards = (fallbackCategories = []) => {
  const [serviceCategories, setServiceCategories] = useState(fallbackCategories);
  const [categoriesLoading, setCategoriesLoading] = useState(false);
  const [categoriesError, setCategoriesError] = useState('');

  useEffect(() => {
    let mounted = true;

    const loadCategoryCards = async () => {
      setCategoriesLoading(true);
      setCategoriesError('');

      try {
        const cards = await catalogService.getServiceCategoryCards();
        if (!mounted) return;

        if (cards.length > 0) {
          setServiceCategories(cards);
        }
      } catch (error) {
        if (!mounted) return;
        setCategoriesError('Unable to refresh categories right now.');
      } finally {
        if (mounted) {
          setCategoriesLoading(false);
        }
      }
    };

    loadCategoryCards();
    return () => {
      mounted = false;
    };
  }, []);

  return {
    serviceCategories,
    categoriesLoading,
    categoriesError
  };
};

export default useHomeCategoryCards;
